"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialIconYoutube = exports.SocialIconTwitter = exports.SocialIconLinkedIn = exports.SocialIconInstagram = exports.SocialIconFacebook = exports.SocialIcon = exports.CompanyBox = exports.TableBox = exports.Position = exports.Description = exports.BodyContent = exports.AddressBox = exports.SocialButtons = exports.MoreInfo = exports.CompanyInfo = exports.ImageBlock = exports.CompanyContent = exports.CompanyBlock = exports.SubText = exports.IconWrapper = exports.CompanyNumbers = exports.NumbersTitle = exports.Body = exports.Subheading = exports.TotalCount = exports.Heading = exports.Header = exports.Main = exports.CompanyMainPanel = exports.StyledPanel = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const mediaFromTablet = '@media screen and (max-width: 768px)';
const mediaFromLaptop = '@media screen and (max-width: 1024px)';
exports.StyledPanel = (0, styled_components_1.default)(elements_1.Panel) `
	&& {
		${mediaFromTablet} {
			padding: 1rem;
		}
	}
`;
exports.CompanyMainPanel = (0, styled_components_1.default)(exports.StyledPanel) `
	&& {
		border-top: none;
		border-radius: 0 0 4px 4px;
	}
`;
exports.Main = styled_components_1.default.div `
	width: 100%;
`;
exports.Header = styled_components_1.default.div `
	width: 100%;
	height: 200px;
	background: black url(${props => props.background}) no-repeat 50%;
	background-size: cover;
	border-radius: 4px 4px 0 0;

	${mediaFromLaptop} {
		height: 90px;
	}
`;
exports.Heading = styled_components_1.default.h2 `
	margin-bottom: 1em;
	color: ${({ theme }) => theme.color.brand1};
	em {
		font-style: normal;
		color: ${({ theme }) => theme.color.gray6};
	}
`;
exports.TotalCount = styled_components_1.default.small `
	margin: 0.5rem 0;
	font-size: 0.8rem;
	color: ${({ theme }) => theme.color.gray6};
`;
exports.Subheading = styled_components_1.default.h3 `
	font-size: 1.25rem;
	color: ${({ theme }) => theme.color.brand2};
`;
exports.Body = styled_components_1.default.div `
	display: flex;
	position: relative;

	${mediaFromLaptop} {
		flex-direction: column;
	}
`;
exports.NumbersTitle = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.gray6};
	font-size: 1rem;
	text-align: center;
`;
exports.CompanyNumbers = styled_components_1.default.div `
	display: flex;
	align-items: center;
	justify-content: space-around;
	margin-bottom: 2rem;
	width: 100%;
	max-width: 400px;
`;
exports.IconWrapper = styled_components_1.default.div `
	display: flex;
	align-items: center;
	justify-content: center;
	height: 44px;
	width: 44px;
	min-width: 44px;
	border-radius: 50%;
	background: ${({ theme }) => theme.color.gray6};

	path {
		fill: white;
	}
`;
exports.SubText = styled_components_1.default.div `
	color: ${({ theme }) => theme.color.gray6};
`;
exports.CompanyBlock = styled_components_1.default.div `
	position: relative;
	width: 400px;
	min-width: 400px;
	margin-right: 1rem;
	margin-bottom: 1rem;

	${mediaFromLaptop} {
		width: 100%;
		min-width: 100%;
		margin-right: 0;
		margin-bottom: 0;
	}
`;
exports.CompanyContent = styled_components_1.default.div `
	padding-top: 4rem;
	display: flex;
	flex-direction: column;
	align-items: center;

	${mediaFromLaptop} {
		padding-top: 2.5rem;
	}
`;
exports.ImageBlock = styled_components_1.default.div `
	position: absolute;
	top: -75px;
	left: 125px;
	border: 1px solid ${props => props.theme.color.gray4};
	background: white;
	z-index: 1;
	width: 150px;
	height: 150px;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 4px;

	${mediaFromLaptop} {
		top: -50px;
		left: calc(50% - 50px);
		width: 100px;
		height: 100px;
	}

	& > * {
		padding: 4px;
		background: white;
		max-width: 100%;
		max-height: 100%;
	}

	svg {
		width: 70%;
		height: 70%;
		color: ${({ theme }) => theme.color.gray4};
	}
`;
exports.CompanyInfo = styled_components_1.default.div `
	width: 100%;
`;
exports.MoreInfo = styled_components_1.default.div `
	width: 100%;
	display: none;
	${mediaFromLaptop} {
		display: block;
	}
`;
exports.SocialButtons = styled_components_1.default.div `
	width: 100%;

	& span.anticon {
		font-size: 2rem;
		color: black;
		margin: 0.4rem;
	}
`;
exports.AddressBox = styled_components_1.default.div `
	margin-top: 2rem;
	width: 100%;
	font-size: 1rem;
`;
exports.BodyContent = styled_components_1.default.div `
	width: 100%;
	max-width: calc(100% - 415px);

	${mediaFromLaptop} {
		width: 100%;
		max-width: 100%;
	}
`;
exports.Description = (0, styled_components_1.default)(exports.CompanyMainPanel) `
	margin: auto;
	font-size: 1rem;

	${mediaFromLaptop} {
		display: none;
	}
`;
exports.Position = (0, styled_components_1.default)(elements_1.Link) `
	display: block;
	padding: 1em;
	color: ${({ theme }) => theme.color.gray9};
	width: 100%;
	border-radius: 4px;
	border: 1px solid ${({ theme }) => theme.color.gray3};
	overflow: hidden;
	position: relative;

	& + & {
		margin: 1em 0 0 0;
	}

	h2 {
		color: ${({ theme }) => theme.color.brand1};
		font-weight: bold;
		font-size: ${({ theme }) => theme.fontSizes.l};
		margin-bottom: 0.3em;
	}

	.type {
		font-weight: bold;
		color: ${({ theme }) => theme.color.gray7};
	}

	.city {
		color: ${({ theme }) => theme.color.gray7};
	}

	.salary {
		font-size: ${({ theme }) => theme.fontSizes.m};
		color: ${({ theme }) => theme.color.brand1};
		font-weight: bold;
		margin-top: 0.3em;
	}

	.detail {
		position: absolute;
		top: 0;
		right: 0;
		height: 100%;
		padding: 2em;
		text-transform: uppercase;
		font-size: 0.9em;
		display: flex;
		align-items: center;
		transition: all 0.2s ease;
		opacity: 0;
		transform: translateX(50px);
		color: ${({ theme }) => theme.color.white};
		background: ${({ theme }) => theme.color.success};
	}

	&:hover {
		cursor: pointer;

		.detail {
			transform: translateX(0);
			opacity: 1;
		}
	}
`;
exports.TableBox = (0, styled_components_1.default)(elements_1.Table) `
	margin-top: 1rem;
	word-break: keep-all;

	${mediaFromLaptop} {
		margin: 0;
	}
	${mediaFromTablet} {
		margin: 0;

		td {
			padding: 16px 8px !important;
		}
	}
`;
exports.CompanyBox = styled_components_1.default.div `
	margin: 1rem auto;
	background: #929292;
	border-radius: 3px;
`;
exports.SocialIcon = (0, styled_components_1.default)(elements_1.Icon) `
	width: 32px;
	svg {
		transition: 0.3s;
	}
`;
exports.SocialIconFacebook = (0, styled_components_1.default)(exports.SocialIcon) `
	svg {
		color: ${({ theme }) => theme.color.brand2};
	}
	&:hover {
		svg {
			fill: ${({ theme }) => theme.color.facebook};
		}
	}
`;
exports.SocialIconInstagram = (0, styled_components_1.default)(exports.SocialIcon) `
	svg {
		color: ${({ theme }) => theme.color.brand2};
	}
	&:hover {
		svg {
			fill: ${({ theme }) => theme.color.instagramGradient};
		}
	}
`;
exports.SocialIconLinkedIn = (0, styled_components_1.default)(exports.SocialIcon) `
	svg {
		color: ${({ theme }) => theme.color.brand2};
	}
	&:hover {
		svg {
			fill: ${({ theme }) => theme.color.linkedin};
		}
	}
`;
exports.SocialIconTwitter = (0, styled_components_1.default)(exports.SocialIcon) `
	svg {
		color: ${({ theme }) => theme.color.brand2};
	}
	&:hover {
		svg {
			fill: ${({ theme }) => theme.color.twitter};
		}
	}
`;
exports.SocialIconYoutube = (0, styled_components_1.default)(exports.SocialIcon) `
	svg {
		color: ${({ theme }) => theme.color.brand2};
	}
	&:hover {
		svg {
			fill: ${({ theme }) => theme.color.youtube};
		}
	}
`;
